import { render, staticRenderFns } from "./UserSetupOnboarding.vue?vue&type=template&id=728af769&scoped=true&"
import script from "./UserSetupOnboarding.vue?vue&type=script&lang=js&"
export * from "./UserSetupOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./UserSetupOnboarding.vue?vue&type=style&index=0&id=728af769&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728af769",
  null
  
)

export default component.exports